// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__24JJd","calendarButtons":"ClockData_calendarButtons__pRoCV"};